import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-skip-to-content', 'linkLabel', 'Pāriet uz lapas galveno saturu');
